<template>
    <v-app>
        <dyeing-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Dyeing Records</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">

                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openChequeBook"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Dyeing Factory
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import dyeingSetup from '@/components/module/production/dyeingSetup.vue';

export default {
    components: {
        dyeingSetup
    },
    data: () => ({
        itemsPerPage:10,
        panel: [0],
        loading:false,
        search: "",
            dialog: false,
        data:{},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Code", key: "code", align: "left", sortable: false },
            { title: "Dyeing Factory Name", key: "name",align: "left" ,sortable: false },
            { title: "Contact Person", key: "contact_person", align: "left", sortable: false },
            { title: "Contact Phone", key: "contact_phone", align: "left", sortable: false },
            { title: "Type", key: "type", align: "left", sortable: false },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
    }),
    watch: {
        dialog(newVal) {
            // Reload list when dialog closes (after save/update)
            if (!newVal) {
                // Small delay to ensure backend has processed the request
                setTimeout(() => {
                    this.loadData();
                }, 300);
            }
        },
    },
    created(){
        this.loadData();
    },
    computed:{
        getSchema() {
            const list = this.$store.getters.getDyeingList || [];
            return Array.isArray(list) ? list : [];
        },
    },
    methods: {
        loadData() {
            this.loading = true;
            this.$store.dispatch('getDyeingList')
                .then((response) => {
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error('Error loading dyeing list:', error);
                    if (error.response) {
                        console.error('Error response data:', error.response.data);
                        console.error('Error response status:', error.response.status);
                    }
                });
        },
        openChequeBook() {
            this.data = {
                id: null,
                name: "",
                contact_person: "",
                contact_phone: "",
                contact_email: "",
                address: "",
                type: "external",
                status: "1",
            };
            this.dialog = true;
        },
        editItem(item){
            this.data = { ...item };
            console.log(this.data)
            this.dialog = true;
        },
        formatExportData() {
            let sl = 1;
            return this.getSchema.map(item => (
                [
                    sl++,
                    item.code,
                    item.name,
                    item.contact_person,
                    item.contact_phone,
                    item.type === "in_house" ? "In House" : "External",
                    item.address,
                    item.status == 1 ? 'Active' : 'Inactive'
                ]
            ));
        },
        exportToPDF() {
            const columns = [
                '#SL',
                'Code',
                'Dyeing Factory Name',
                'Contact Person',
                'Contact Phone',
                'Type',
                'Address',
                'Status'
            ];
            const rows = this.formatExportData();

            this.$exportTableToPDF(
                columns,
                rows,
                'Dyeing List',
                'dyeing_list_' + this.$fileDate()
            );
        },

        exportToExcel() {
            const data = [
                ['#SL', 'Code', 'Dyeing Factory Name', 'Contact Person', 'Contact Phone', 'Type', 'Address', 'Status'],
                ...this.formatExportData()
            ];

            this.$exportTableToExcel(
                data,
                'dyeing_list_' + this.$fileDate()
            );
        },

        exportToCSV() {
            const data = [
                ['#SL', 'Code', 'Dyeing Factory Name', 'Contact Person', 'Contact Phone', 'Type', 'Address', 'Status'],
                ...this.formatExportData()
            ];

            this.$exportTableToCSV(
                data,
                'dyeing_list_' + this.$fileDate()
            );
        },

    },
    mounted() {

    }  
}
</script>